import ReduxProvider from 'redux/provider'
import App from 'modules/app/app'
import AppTheme from 'modules/app/app-theme'
import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'

interface AppWrapperProps {
  env?: string
  config?: Config
  urlParams: URLParams
}

const AppWrapper = ({ env, config, urlParams }: AppWrapperProps) => {
  if (!env || !config) {
    return <div>ErrorStateNeeded</div>
  }

  return (
    <>
      <ReduxProvider config={config} urlParams={urlParams}>
        <AppTheme>
          <App env={env} />
        </AppTheme>
      </ReduxProvider>
    </>
  )
}

export default AppWrapper
